import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import TreechatPng from 'assets/treechat.png'

export interface TreechatIconPngProps {
    contextStyles?: string
    hoverStyles?: string
    selectedStyles?: string
    initialStyles?: string
}

export default function TreechatIconPng({
    contextStyles,
    hoverStyles,
    selectedStyles,
}: TreechatIconPngProps) {
    return (
        <div className={cn(styles.treechatIconPng, contextStyles, hoverStyles, selectedStyles)}>
            <img src={TreechatPng} />
        </div>
    )
}
